export default __webpack_public_path__ + "static/media/req.c82ca587.png";